import { postFetch, getGssfServerList, formDataPostFetch } from '../utils/request';
import { entity, islocation } from '../utils/entity';

const requestUrl = "https://" + (islocation('qa') || islocation('dev') || islocation('prv')|| islocation('localhost') ? entity.qaService : entity.service);
/**
 * @desc: 获取手机验证码
 * @param {type} phone { string } 手机号
 * @return: 
 *  url	string	文件地址
 */
export async function getPhoneCode(data) {
    return postFetch(requestUrl + '/api/ticket/phone-code', {
        phone: data.phone
    });
}

/**
 * @desc: 获取游戏列表
 * @return: 
 *  webgame2018	{ object of arr }	网页游戏
 *  mobgame	{ object of arr }	手机游戏
 *  object参数如下：
 *  game_name	string	游戏名称
 *  game_id	    int	    游戏id
 *  game_type	string	游戏类型  1、页游  2、手游
 *  img	        string	游戏图片
 *  is_ticket	int	    是否配置工单系统 （1 是则渲染列表，0 否则不渲染）
 */
export async function getAllGames(data) {
    return postFetch(requestUrl + '/api/ticket/all-games', {});
}

/**
 * @desc: 根据游戏获取渠道op_id列表
 * @param {type} game_id {init} 游戏id
 * @param {type} game_type {init} 游戏类型 1、页游  2、手游
 * @return: 
 *  data	{ object of arr }	网页游戏
 *  object参数如下：
 *  op_id	    int	    渠道id
 *  op_name	    string	渠道名称
 */
export async function getOpIdList(data) {
    return postFetch(requestUrl + '/api/ticket/all-games', {
        game_id: data.game_id,
        game_type: data.game_type,
    });
}

/**
 * @desc: 根据游戏获取区服server_list列表
 * @param {type} game_id {init} 游戏id
 * @param {type} op_id {init} 渠道id
 * @return: 
 *  data	{ object of arr }	网页游戏
 *  object参数如下：
 *  server_id	    int	    区服id
 *  server_name	    string	区服名称
 */
export async function getServerList(data) {
    return getGssfServerList(data.game_id, data.op_id);
}

/**
 * @desc: 根据游戏及区服获取用户角色
 * @param {type} account {int} 用户账号
 * @param {type} game_type {int} 游戏类型 1、页游 2、手游
 * @param {type} game_id {int} 游戏id
 * @param {type} op_id {int} 渠道id
 * @param {type} server_id {int} 区服id
 * @return: 
 *  data	{ object of arr }	网页游戏
 *  object参数如下：
 *  op_id	    int	    平台id
 *  op_name	    string	平台名称
 */
export async function getRoleList(data) {
    return postFetch(requestUrl + '/api/ticket/game-rolelist', {
        account: data.account,
        game_type: Number(data.activeGameType),
        game_id: Number(data.game_id),
        op_id: Number(data.op_id),
        server_id: Number(data.server_id),
    });
}

/**
 * @desc: 获取分类 （服务中转：后台转调国内客服后台）
 * @param {type} method {string} 转接后台地址
 * @param {type} id {init} 游戏id
 * @return: 
 *  list	{ object of arr }	分类列表
 *  object参数如下：
 *  name    	string	分类标题
 *  img	        string	暂无用途
 *  templates   { Object of arr }	子分类列表
 *      Object参数如下：
 *      id    	    int  	分类id
 *      title	    string	模板标题
 *      img	        string	分类图片
 *      desc    	string	分类描述
 *      needVerify	Boolean 待确认	
 */
export async function getCategory(data) {
    return postFetch(requestUrl + '/api/ticket/index', {
        method: 'TicketFrontService.getTemplateList',
        gameId: Number(data.gameId),
        type: "2"
    });
}

/**
 * @desc: 获取模板 （服务中转：后台转调国内客服后台）
 * @param {type} method {string} 转接后台地址
 * @param {type} tplId {init} 分类id
 * @return: 
 *  id    	    int	    分类id
 *  tpl_id    	int	    模板id
 *  title    	string	模板标题
 *  img    	    string	待确认
 *  desc    	string	模板的介绍
 *  needVerify	Boolean	待确认
 *  fields   { Object of arr }	自定义字段
 *      Object参数如下：
 *      type    	int  	字段类型
 *      name	    string	字段标题名称
 *      content	    string  字段填充内容（原接口案例为Object类型，需要确认）
 *      desc    	string	字段的介绍，用法参见原型
 *      required	Boolean 是否必填	
 *      uid     	int     唯一id	
 */
export async function getTemplate(data) {
    return postFetch(requestUrl + '/api/ticket/index', {
        method: 'TicketFrontService.getTemplate',
        tplId: Number(data.tplId)
    });
}

/**
 * @desc: 创建工单 （服务中转：后台转调国内客服后台）
 * @param {type} "entity_id": 1, // 主体 1游族 2杜尚
 * @param {type} "id": 0, // 永远是0
 * @param {type} "account":"1234568", // 内部账号
 * @param {type} "status":0, // 永远是0
 * @param {type} "source":1, //1 平台service，3 QQ，4 微信，5 电话，6 七鱼
 * @param {type} "source_number":"", // qq号/微信号/手机号，没有放空
 * @param {type} "leaf_cat_id":0, // 永远是0
 * @param {type} "game_id":200,
 * @param {type} "op_id":2107,
 * @param {type} "role_name":"角色名",
 * @param {type} "server_id":"服务器id",
 * @param {type} "tpl_id":1, // template id
 * @param {type} "content":"{}", // 所有自定义字段，详情见自定义模板文档
 * @param {type} "cur_handler":"", // 永远是空
 * @param {type} "group_id":0, // 永远是0
 * @param {type} "last_update_time":0, // 永远是0
 * @param {type} "classify":1, // classify id, 理论上用不到
 * @param {type} "create_time":0, // 永远是0
 * @param {type} "satisfaction":0, // 永远是0
 * @param {type} "rating_status":0, // 永远是0
 * @param {type} "completion":0, // 永远是0
 * @param {type} "evaluator":"" // 永远是空
 * 备注：
 * @return: {}
 */
// createTicket: function (account, game_id, op_id, role_name, server_id, tpl_id, content, callback) {
export async function createTicket(data) {
    return postFetch(requestUrl + '/api/ticket/index', {
        method: 'TicketFrontService.createTicket',
        ...data
    });
}

/**
 * @desc: 获取单个工单 （服务中转：后台转调国内客服后台）
 * @param {type} method {string} 转接后台地址
 * @param {type} ticketId {init} 工单id
 * @return: 
 *  "id": 0, // 永远是0
 *  "account":"1234568", // 内部账号
 *  "status":0, // 永远是0
 *  "source":1, //1 平台service，3 QQ，4 微信，5 电话，6 七鱼
 *  "source_number":"", // qq号/微信号/手机号，没有放空
 *  "leaf_cat_id":0, // 永远是0
 *  "game_id":200,
 *  "op_id":2107,
 *  "role_name":"角色名",
 *  "server_id":"服务器id",
 *  "tpl_id":1, // template id
 *  "content":"{}", // 所有自定义字段，详情见自定义模板文档
 *  "cur_handler":"", // 永远是空
 *  "group_id":0, // 永远是0
 *  "last_update_time":0, // 永远是0
 *  "classify":1, // classify id, 理论上用不到
 *  "create_time":0, // 永远是0
 *  "satisfaction":0, // 永远是0
 *  "rating_status":0, // 永远是0
 *  "completion":0, // 永远是0
 *  "evaluator":"" // 永远是空
 */
export async function getOneTicket(data) {
    return postFetch(requestUrl + '/api/ticket/index', {
        method: 'TicketFrontService.getOneTicket',
        ticketId: Number(data.ticketId)
    });
}

/**
 * @desc: 获取玩家的工单列表 （服务中转：后台转调国内客服后台）
 * @param {type} method {string} 转接后台地址
 * @param {type} account {string} 内部账号
 * @param {type} pagination {Object} 内部账号
 *  Object: 
 *  @param {type} limit {init} 请求条数,
 *  @param {type} offset {init} OFFSET理解成开端索引或者叫起始索引，OFFSET后面跟索引,
 * @return: 
 *  "id": 0, // 永远是0
 *  "account":"1234568", // 内部账号
 *  "status":0, // 永远是0
 *  "source":1, //1 平台service，3 QQ，4 微信，5 电话，6 七鱼
 *  "source_number":"", // qq号/微信号/手机号，没有放空
 *  "leaf_cat_id":0, // 永远是0
 *  "game_id":200,
 *  "op_id":2107,
 *  "role_name":"角色名",
 *  "server_id":"服务器id",
 *  "tpl_id":1, // template id
 *  "content":"{}", // 所有自定义字段，详情见自定义模板文档
 *  "cur_handler":"", // 永远是空
 *  "group_id":0, // 永远是0
 *  "last_update_time":0, // 永远是0
 *  "classify":1, // classify id, 理论上用不到
 *  "create_time":0, // 永远是0
 *  "satisfaction":0, // 永远是0
 *  "rating_status":0, // 永远是0
 *  "completion":0, // 永远是0
 *  "evaluator":"" // 永远是空
 */
export async function getTicketList(data) {
    return postFetch(requestUrl + '/api/ticket/index', {
        method: 'TicketFrontService.getTicketList',
        account: data.account,
        page: 1,
        pageSize: 10
    });
}

/**
 * @desc: 更新工单满意度和完成度 （服务中转：后台转调国内客服后台）
 * @param {type} method {string} 转接后台地址
 * @param {type} id {init} 分类模板id
 * @param {type} csi {init} 满意度 1~5 非常不满意~非常满意
 * @param {type} resolved {init} 解决度 1 未解决 0 已解决
 * @return: {}
 */
export async function updateTicketSatisfaction(data) {
    return postFetch(requestUrl + '/api/ticket/index', {
        method: 'TicketFrontService.updateTicketSatisfaction',
        account: data.account,
        ticketId: Number(data.id),
        csi: Number(data.csi),
        resolved: Number(data.resolved),
    });
}

/**
 * 获取工单对话记录
 * @param {number} ticketId 工单id
 * @param {*} callback 
 */
export async function ticketInfoList(data) {
    return postFetch(requestUrl + '/api/ticket/index', {
        method: 'TicketFrontService.ticketInfoList',
        ticketId: Number(data.ticketId),
        role: 2
    });
}

/**
  * 回复工单
  * @param {number} id 工单id
  * @param {object} meta 信息
  * @param {function} callback 
  */
export async function ticketInfoReply(data) {
    return postFetch(requestUrl + '/api/ticket/index', {
        method: 'TicketFrontService.ticketReply',
        ticketId: Number(data.id),
        content: data.content,
        file_url: data.file_url,
        account: data.account,
        role: 2,
    });
}

/**
 * 工单消息已读
 * @param {number} ticketId 工单id
 * @param {function} callback 
 */
export async function ticketInfoRead(data) {
    return postFetch(requestUrl + '/api/ticket/index', {
        method: 'TicketFrontService.ticketRead',
        ticketId: Number(data.ticketId),
        role: 2,
    });
}

/**
 * 图片上传
 * @param {number} id 工单id
 * @param {function} callback 
 */
export async function fileUpload(data) {
    return formDataPostFetch(requestUrl + '/api/ticket/upload', data);
}

// ?account=16149137860600006467&clientVersion=111&expand=333&game_id=352&netWorkType=WIFI&op_id=2107&phoneModel=WLZ-AN00&role_id=123&serverVersion=222&server_id=034401&sign=52b5527fb4640358876fd4493ae4a0b8